import * as React from "react";
import { Drawer, Button } from "@material-ui/core";
import { Close as IconClose } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import "./index.scss";

interface BottomSheetProps {
  children: React.ReactNode;
  open: boolean;
  showClose?: boolean;
  onClose?: () => void;
  radius?: number;
  className?: string;
}

const DEFAULT_RADIUS = 0;

/**
 * IMPORTANT:
 * makeStyles MUST be outside the component
 */
const useStyles = makeStyles(() => ({
  paper: {
    width: "100%",
    height: "100%",
    maxWidth: 576,
    marginLeft: "auto",
    marginRight: "auto",
    background: "transparent",
    boxShadow: "none",
    overflow: "visible", // important for rounded corners
  },
}));

const BottomSheet: React.FC<BottomSheetProps> = ({
  children,
  open,
  showClose = false,
  onClose,
  radius = DEFAULT_RADIUS,
  className = "",
}) => {
  const classes = useStyles();

  const handleClose = () => {
    onClose?.();
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      classes={{ paper: classes.paper }}
      ModalProps={{
        keepMounted: true, // better mobile performance
      }}
    >
      <div
        className={`bottom-sheet-container ${className} ${open ? "open" : ""}`}
        style={{
          borderTopLeftRadius: radius,
          borderTopRightRadius: radius,
        }}
      >
        <div className="bottom-sheet-main-container">
          {showClose && (
            <div className="header-row text-right">
              <Button onClick={handleClose} className="close-button">
                <IconClose htmlColor="#fff" />
              </Button>
            </div>
          )}

          {children}
        </div>
      </div>
    </Drawer>
  );
};

export { BottomSheet };
